module.exports = __webpack_public_path__ + "static/logo-ce6597e2c730e53c97b823f123328826.svg";